import moment from 'moment-timezone'

export default {
  computed: {
    subscription() {
      return this.activeCompany.subscription
    },

    isSubscribed() {
      return !!this.subscription || this.activeCompany.hasAppSumoLicense()
    },

    hasLastSubscription() {
      return this.activeCompany.last_subscription !== null
    },

    hasProperSubscription() {
      return this.activeCompany.hasProperSubscription
    },

    activeEmploymentsCount() {
      return this.activeCompany.employments_count
    },

    isSubscriptionActive() {
      if (this.activeCompany.hasAppSumoLicense()) return true

      return (
        !!this.subscription &&
        this.subscription.stripe_status === 'active' &&
        this.activeCompany.current_subscription.ends_at === null
      )
    },

    isCanceled() {
      return (
        !!this.subscription &&
        this.activeCompany.current_subscription.ends_at !== null
      )
    },

    isPreviousCustomer() {
      return (
        !this.isSubscriptionActive &&
        this.activeCompany.last_subscription !== null
      )
    },

    isNewCustomer() {
      return !this.isSubscribed && this.activeCompany.last_subscription == null
    },

    isManuallyBilled() {
      return this.activeCompany.manually_billed === true
    },

    hasPaymentIssue() {
      if (this.subscription && this.subscription.stripe_status !== null) {
        return (
          this.subscription.stripe_status === 'incomplete' ||
          this.subscription.stripe_status === 'incomplete_expired' ||
          this.subscription.stripe_status === 'unpaid'
        )
      }
      return false
    },

    isInGracePeriod() {
      if (this.subscription) {
        return moment(this.subscription.ends_at).isSameOrAfter(
          moment().utc(true)
        )
      }
      return false
    },

    subscribedPlan() {
      if (this.subscription) return this.subscription.plan.name

      if (this.activeCompany.hasAppSumoLicense()) {
        return this.activeCompany.current_billing_plan
      }

      return 'Free'
    },

    numberOfSeats() {
      if (this.activeCompany.isInTrialPeriod()) {
        return Infinity
      }

      if (this.subscription) return this.subscription.quantity

      if (this.activeCompany.hasAppSumoLicense()) {
        return this.activeCompany.appsumo_license.seats
      }

      return 5
    },

    createdAt() {
      if (!this.subscription) return null
      return this.subscription.created_at
    },

    endsAt() {
      if (!this.subscription) return null
      return this.subscription.ends_at
    },
  },
}
